"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "daily-history-table"
  }, [_c("b-table", {
    attrs: {
      data: _vm.data,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "imageUrl",
      label: "",
      width: "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$punchIn, _props$row$punchIn2, _props$row$punchIn3;
        return [_c("figure", {
          staticClass: "avatar",
          class: {
            "no-image": !((_props$row$punchIn = props.row.punchIn) !== null && _props$row$punchIn !== void 0 && _props$row$punchIn.imagePreview)
          }
        }, [(_props$row$punchIn2 = props.row.punchIn) !== null && _props$row$punchIn2 !== void 0 && _props$row$punchIn2.imagePreview ? _c("img", {
          attrs: {
            src: (_props$row$punchIn3 = props.row.punchIn) === null || _props$row$punchIn3 === void 0 ? void 0 : _props$row$punchIn3.imagePreview,
            alt: "avatar"
          }
        }) : _vm._e()])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "name",
      label: "Funcionário"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.user.firstName) + " " + _vm._s(props.row.user.lastName) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "date",
      label: "Dia"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.date)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "entry",
      label: "Entrada"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$punchIn4;
        return [_vm._v("\n      " + _vm._s(_vm.formatTime((_props$row$punchIn4 = props.row.punchIn) === null || _props$row$punchIn4 === void 0 ? void 0 : _props$row$punchIn4.clockedAt)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "exit",
      label: "Saída"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$punchOut;
        return [_vm._v("\n      " + _vm._s(_vm.formatTime((_props$row$punchOut = props.row.punchOut) === null || _props$row$punchOut === void 0 ? void 0 : _props$row$punchOut.clockedAt)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "worked",
      label: "Horas trabalhadas"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatSeconds(props.row.workedSeconds)) + "\n    ")];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;